import { ImageCircle } from '$components'
import { ClientRoutePath } from '$features/clients/routes/protected'
import { QueryParams, Router } from '$utils/router'
import { Text } from '$components'
import { Link } from 'react-router-dom'

export type ClientCellProps = {
  data: {
    id: number,
    first_name: string,
    last_name: string,
    image: string,
  }
  query?: QueryParams
}

export function ClientCell({ data, query }: ClientCellProps) {

  return (
    <Link
      to={
        Router.buildRoute(
          Router.getRoute(ClientRoutePath.ClientsView, { id: data.id.toString() }),
          ClientRoutePath.ClientsDetails,
          query,
        )}
      className="relative z-[2] flex gap-stack-tight items-center border border-border w-fit rounded-pill py-stack-dense pl-stack-dense pr-stack-roomy hover:border-border-focus bg-surface transition-colors"
    >
      <ImageCircle
        image={data.image}
        size="md"
      />
      <Text type="s" className="text-nowrap truncate max-w-32">
        { data.first_name } { data.last_name }
      </Text>
    </Link>
  )
}
